export default __webpack_public_path__ + "static/media/desk-cleaning-1000px.a3f8218d.jpg";